import IconArrowLeft from '../icons/arrow-left';
import IconLoader from '../icons/loader';
import IconSelected from '../icons/selected';
import { AccountsListTypes } from './types';
import Checkbox from '../checkbox/checkbox';
import { Account as AccountItem } from '../transactions-sidepanels/types';

import styles from './accounts-selector.module.css';

export default function AccountsList({
  onBack,
  selectedCategoryNumber,
  selectedGroupNumber,
  selectedPrimaryAccount,
  accountsIsLoading,
  accounts,
  setSelectedAccount,
  account,
  toggle,
  setAccount,
  setSelectedCategoryId,
  setSelectedGroupId,
  setSelectedPrimaryAccountId,
  multiple,
  selectedAccounts,
  setSelectedAccounts,
}: AccountsListTypes) {
  let content;

  if (accountsIsLoading) {
    content = (
      <li className={styles.loaderWrapper}>
        <IconLoader className={styles.loader} />
      </li>
    );
  } else if (!accountsIsLoading && accounts && accounts?.length > 0) {
    content = accounts?.map((item) => (
      <li key={item.id} className={styles.accountItem}>
        {multiple && (
          <div className={styles.accountCheckboxWrapper}>
            <Checkbox
              type="checkbox"
              title={item.description}
              name={`account-${item.id}`}
              checked={Boolean(
                selectedAccounts?.find(
                  (accountValues) => accountValues?.id === item.id,
                ),
              )}
              description={item.fullNumber}
              onChange={() => {
                let nextSelectedAccounts = ([] as AccountItem[]).concat(
                  selectedAccounts as AccountItem[],
                );

                if (
                  nextSelectedAccounts?.find(
                    (accountValues) => accountValues?.id === item.id,
                  )
                ) {
                  nextSelectedAccounts = nextSelectedAccounts?.filter(
                    (accountValues) => accountValues?.id !== item.id,
                  );
                } else {
                  nextSelectedAccounts.push(item);
                }

                setSelectedAccounts(nextSelectedAccounts);
              }}
            />
          </div>
        )}
        {!multiple && (
          <button
            type="button"
            className={`${styles.categoryButton} ${styles.accountButton} ${
              account?.id === item.id ? styles.selectedAccount : ''
            }`}
            tabIndex={-1}
            onClick={() => {
              setSelectedAccount(item.fullNumber);
              setAccount(item);
              toggle(false);

              if (!selectedCategoryNumber) {
                setSelectedCategoryId(item.categoryId);
              }

              if (!selectedGroupNumber) {
                setSelectedGroupId(item.groupId);
              }

              if (!selectedPrimaryAccount) {
                setSelectedPrimaryAccountId(item.primaryId);
              }
            }}
          >
            <div
              className={`${styles.categoryButtonLeft} ${styles.accountButtonLeft}`}
            >
              {item.description}
            </div>
            <div className={styles.categoryButtonRight}>
              <div
                className={`${styles.categoryButtonNumber} ${styles.accountNumber}`}
              >
                {item.fullNumber}
              </div>
              {account?.id === item.id && <IconSelected />}
            </div>
          </button>
        )}
      </li>
    ));
  } else if (!accountsIsLoading && !accounts?.length) {
    content = <li className={styles.emptyAccounts}>No accounts found</li>;
  }

  return (
    <>
      {selectedPrimaryAccount && (
        <li className={styles.groupsTitle}>
          <button type="button" className={styles.backButton} onClick={onBack}>
            <IconArrowLeft />
            <div className={styles.categoryTitle}>
              {`${selectedCategoryNumber}.${selectedGroupNumber}.${selectedPrimaryAccount?.number} ${selectedPrimaryAccount?.description}`}
            </div>
          </button>
        </li>
      )}

      {content}
    </>
  );
}
